var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M81.576,78.225l-0.454,0.453c1.592,3.414,4.321,7.735,8.65,9.789c1.369,0.685,1.139,2.961-0.453,3.183\n\tc-4.783,0.685-11.611,0-17.977-5.005c-16.163,9.557-37.323,7.281-51.211-6.598c-16.616-16.616-16.616-43.244,0-59.861\n\tc16.617-16.617,43.244-16.617,59.861,0C95.686,36.35,96.139,61.605,81.576,78.225L81.576,78.225z M44.475,32.02\n\tc0.231,2.729,0.231,5.237,0.454,7.966c0.231,4.099,0.454,8.197,0.685,12.287c0,1.369,0.231,2.508,0.231,3.868\n\tc0,2.275,1.823,3.867,3.868,3.867c2.044,0,3.868-1.592,3.868-3.647c0.231-6.375,0.685-12.75,1.138-19.115\n\tc0-1.822,0.231-3.414,0.231-5.236c0.231-2.729-1.369-5.006-3.868-5.69c-2.507-0.685-5.005,0.685-6.143,2.961\n\tc-0.231,0.924-0.462,1.831-0.462,2.738V32.02z M55.17,68.896c0-2.961-2.275-5.237-5.236-5.237c-2.96,0-5.236,2.508-5.236,5.459\n\tc0,2.729,2.507,5.236,5.236,5.236C52.672,74.354,55.17,71.848,55.17,68.896z"}));
}

Warning.defaultProps = {"version":"1.1","id":"Calque_1","x":"0px","y":"0px","width":"100%","height":"100%","viewBox":"0 0 100 100","enableBackground":"new 0 0 100 100","xmlSpace":"preserve"};

module.exports = Warning;

Warning.default = Warning;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/assets/warning.svg
// module id = 430
// module chunks = 0